import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { crmAuthInterceptor, CrmAuthResetPasswordSuccessProviderImpl, crmProvideAuth } from '@touch4it/ng-swp/auth';
import { crmProvideAppConfig } from '@touch4it/ng-swp/core';
import { crmProvideEndpoint } from '@touch4it/ng-swp/endpoint';
import { crmProvideMessage } from '@touch4it/ng-swp/message';
import { crmProvideModal } from '@touch4it/ng-swp/modal';
import { crmProvideTranslate } from '@touch4it/ng-swp/translate';
import { CrmUserService } from '@touch4it/ng-swp/user';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { crmProvideEditor } from '@touch4it/ng-swp/editor';
import { crmProvideLayout } from '@touch4it/ng-swp/layout-v2';

import { ResetPasswordSuccessProvider } from '~/shared/crm/auth/reset-password-success.provider';
import { UserService } from '~/shared/crm/user/user.service';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { routes } from './app/app.routes';
import { authConfig } from './app/config/auth.config';
import { endpointConfig } from './app/config/endpoint.config';
import { environment } from './environments/environment';
import { translateConfig } from './app/config/translate.config';
import { layoutConfig } from './app/config/layout.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([crmAuthInterceptor])),
    provideRouter(routes),

    crmProvideAppConfig(appConfig),
    crmProvideTranslate(translateConfig),
    crmProvideAuth(authConfig),
    crmProvideEndpoint(endpointConfig),
    crmProvideLayout(layoutConfig),
    crmProvideModal(),
    crmProvideMessage(),
    crmProvideEditor(),

    { provide: CrmUserService, useExisting: UserService },
    { provide: CrmAuthResetPasswordSuccessProviderImpl, useClass: ResetPasswordSuccessProvider },
  ],
}).catch((err) => console.error(err));
